function formatAffiliateCookie(cid) {
    if (typeof cid !== 'string') {
        return null;
    }
    const parts = cid.split('_');
    const type = parts[0].toUpperCase();
    parts.shift();
    const now = new Date();
    const timeNoMilliseconds = now.toISOString().split('.')[0];
    const id = parts.join('').toUpperCase();

    return `${id}||${timeNoMilliseconds}|${type}`;
}

module.exports = formatAffiliateCookie;
